export function InfoTip({ text }: { text: string }) {
  return (
    <div className="tooltip tooltip-bottom whitespace-pre-line" data-tip={text}>
      <span className="ml-1 opacity-50 cursor-help select-none">ⓘ</span>
    </div>
  );
}
